import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const ERRORS = {
  microsoft: "Microsoft sign-in was cancelled or failed.",
  state: "Sign-in could not be verified. Please try again.",
  verifier: "Sign-in session expired. Please try again.",
  token: "Could not complete Microsoft sign-in.",
  graph: "Could not read your Microsoft profile.",
  profile: "Your Microsoft account is missing an email address.",
};

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [params] = useSearchParams();

  useEffect(() => {
    const err = params.get("error");
    if (err) {
      toast.error(ERRORS[err] || "Microsoft sign-in failed.");
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      const me = await refresh();
      if (!me) {
        navigate("/login", { replace: true });
      } else if (me.status === "pending") {
        navigate("/pending", { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin text-brand" /> Signing you in…
      </div>
    </div>
  );
}
